import { render, staticRenderFns } from "./AppliedLocationsDialog.vue?vue&type=template&id=0b3cae20&scoped=true&"
import script from "./AppliedLocationsDialog.vue?vue&type=script&lang=ts&"
export * from "./AppliedLocationsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3cae20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
